import { Button, notify } from '@affine/component';
import { ServerService } from '@affine/core/modules/cloud';
import { useI18n } from '@affine/i18n';
import { PageIcon } from '@blocksuite/icons/rc';
import { useService } from '@toeverything/infra';

import { UserMcpCredentialsPanel } from '../../../account-setting/user-mcp-credentials-panel';
import { IntegrationSettingHeader } from '../setting';
import * as styles from './setting-panel.css';

const staticResourceUrl = (baseUrl: string, path: string) => {
  const url = new URL(baseUrl);
  const basePath = url.pathname.replace(/\/+$/, '');
  url.pathname = `${basePath}/${path.replace(/^\/+/, '')}`;
  url.search = '';
  url.hash = '';
  return url.toString();
};

export const DocumentationSkillSettingPanel = () => {
  const t = useI18n();
  const server = useService(ServerService).server;
  const skillUrl = staticResourceUrl(
    server.baseUrl,
    'mcp/cangjie-affine-skill.zip'
  );
  const copyPrompt = async () => {
    await navigator.clipboard.writeText(
      [
        '请安装并使用 Cangjie.Affine Skill 来操作我的 cangjie.affine 文档。',
        `下载 Skill：${skillUrl}`,
        '配置 CANGJIE_AFFINE_TOKEN 和 CANGJIE_AFFINE_ENDPOINT 后，使用这个 Skill 读取、搜索、创建、编辑、重命名、移动、软删除和恢复文档，查看历史版本，读取和管理评论/回复，读取表格，并按 Skill 中的接口执行附件和表格操作。实际可用工具取决于凭证权限和 tools/list；如果授予对应权限，也可以操作原生块、批量、事件和 Webhook。更新已有文档时，先读取文档版本，再用 Markdown 文件和该版本执行 update。',
      ].join('\n\n')
    );
    notify.success({ title: t['Copied to clipboard']() });
  };

  return (
    <div className={styles.stack}>
      <IntegrationSettingHeader
        icon={<PageIcon />}
        name={t['com.affine.integration.documentation-skill.name']()}
        desc={t['com.affine.integration.documentation-skill.desc']()}
      />
      <section className={styles.panel}>
        <div>
          <div className={styles.title}>
            {t[
              'com.affine.integration.documentation-skill.capabilities.title'
            ]()}
          </div>
          <div className={styles.description}>
            {t[
              'com.affine.integration.documentation-skill.capabilities.description'
            ]()}
          </div>
        </div>
        <ul className={styles.capabilities}>
          {(['read', 'search', 'write', 'manage'] as const).map(key => (
            <li className={styles.capability} key={key}>
              {t[
                `com.affine.integration.documentation-skill.capabilities.${key}`
              ]()}
            </li>
          ))}
        </ul>
        <div className={styles.description}>
          {t['com.affine.integration.documentation-skill.install.description']({
            url: skillUrl,
          })}
        </div>
        <code className={styles.code}>{skillUrl}</code>
        <div className={styles.actions}>
          <a
            className={styles.link}
            href={skillUrl}
            download="cangjie-affine-skill.zip"
          >
            {t['com.affine.integration.documentation-skill.action.download']()}
          </a>
          <Button onClick={() => copyPrompt().catch(() => undefined)}>
            {t[
              'com.affine.integration.documentation-skill.action.copy-prompt'
            ]()}
          </Button>
        </div>
      </section>
      <UserMcpCredentialsPanel skillKind="documentation" />
    </div>
  );
};
